import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeadersUtils } from 'maestro-ng';
import { environment } from '../environments/environment';
import { AplicacaoDados } from './aplicacao/aplicacao-dados.model';
import { Sistema } from './monitoramento/sistema.model';
import { BaseService } from './services/base-service.service';
import {firstValueFrom} from 'rxjs';

@Injectable()
export class AppService extends BaseService<AplicacaoDados, number> {

  configs = environment;

  constructor(
    http: HttpClient
  ) {
    super('aplicacao', http);
  }

  public baseUrl(path: string): string {
    return this.configs.paths.base + path;
  }

  public createJsonHttpHeaders(): HttpHeaders {
    return HttpHeadersUtils.contentTypeJson();
  }

  public getBasePath(): string {
    return this.baseUrl('/dados');
  }

  public recuperarDados(): Promise<AplicacaoDados> {
    const urlDados = this.service.path('dados');
    return firstValueFrom(this.http.get<AplicacaoDados>(urlDados));
  }

  public recuperarDadosSistema(): Promise<Sistema> {
    const urlSistema = this.service.path('sistema');
    return firstValueFrom(this.http.get<Sistema>(urlSistema));
  }
}
